/**
 * Megamenu
 *
 * Let's the navigation appear as a clickable Megamenu with
 * one huge layer as dropdown.
 */

(function Megamenu() {
    const nav = $('.megamenu');
    const navMobileTrigger = $('.nav-mobile-trigger');
    const navMobileBack = $('.nav-mobile-back');
    const rootline = nav.find('.root');
    const body = $('body');
    const header = nav.closest('header');
    const classes = {
        active: 'is-active',
        activeNav: 'has-active-nav',
        activeNavOpen: 'has-active-nav-open',
        bodyScroll: 'no-scrolling',
        bodyScrollMobile: 'no-scrolling-mobile'
    };

    /**
     * Create the Megamenu
     */
    function create() {
        let onResizeTimerId;
        rootline.children('a').removeAttr('href');

        $.each(rootline, function(index, element) {
            attachEvent($(element));
        });

        $(window)
            .on('click', function(event) {
                if ($(window).width() > 989 && event.target.tagName != 'A' && header.hasClass(classes.activeNavOpen)) {
                    resetAll();
                }
            })
            .on('resize', function() {
                clearTimeout(onResizeTimerId);
                onResizeTimerId = setTimeout(resetAll, 250);
            });

        initMobileNav();
        resetAll();
    }
    
    /**
     * Attach needed events to nav items
     * @param navItem
     */
    function attachEvent(navItem) {
        navItem.on('click', function(event) {
            if (event.target.tagName == 'SPAN') {
                event.preventDefault();
                return false;
            }

            toggleLayer($(this), event);
        });
    }

    /**
     * Toggle a layer
     * @param navItem
     */
    function toggleLayer(navItem, event) {
        if ($(window).width() < 991 && typeof event.target.href != 'undefined' && event.target.href.length > 0) {
            event.preventDefault();
            location.href = event.target.href;
            return;
        }

        resetNav();

        header.stop(true, true).addClass(classes.activeNavOpen);
        navItem.children('a').stop(true, true).addClass(classes.active);
        navItem.children('.layer').stop(true, true).addClass(classes.active);
    }

    /**
     * Close a layer
     */
    function resetNav() {
        let activeLayer = nav.find('.layer.' + classes.active);

        if (activeLayer.length > 0) {
            activeLayer.closest('li').children('a').stop(true, true).removeClass(classes.active);
            activeLayer.stop(true, true).delay(500).removeClass(classes.active);
        }

        updateScrolling();
    }

    /**
     * Toggle enable/disable scrolling while menu is open
     */
    function updateScrolling() {
        if ($(window).width() > 990) {
            let activeLayer = nav.find('.layer.' + classes.active);

            if (activeLayer.hasClass(classes.active)) {
                if (!body.hasClass(classes.bodyScroll)) {
                    body.addClass(classes.bodyScroll);
                }
            } else {
                body.removeClass(classes.bodyScroll);
            }
        }
    }

    /**
     * Initialize mobile navigation
     */
    function initMobileNav() {
        navMobileTrigger.on('click', function() {
            let activeLayer = nav.find('.layer.' + classes.active);

            header.toggleClass(classes.activeNav);
            body.toggleClass(classes.bodyScrollMobile);

            if (activeLayer.length > 0) {
                resetNav();
            }
        });

        navMobileBack.removeAttr('href');

        navMobileBack.on('click', function() {
            header.removeClass(classes.activeNavOpen);
            resetNav();
        });

        if ($(window).width() < 991) {
            let layer = nav.find('.layer');

            if (layer.height() < $(window).height()) {
                layer.height($(window).height() - 77);
            }
        }
    }

    /**
     * Reset
     */
    function resetAll() {
        body.removeClass(classes.bodyScrollMobile);
        body.removeClass(classes.bodyScroll);
        header.removeClass(classes.activeNav);
        header.removeClass(classes.activeNavOpen);
        resetNav();
    }

    /**
     * Initialize the Megamenu
     */
    if (nav.length > 0 && rootline.length > 0) {
        create();
    }
})();